const API_URL = process.env.REACT_APP_BACKEND_URL;

const headers = () => {
  const token = localStorage.getItem('rbr_token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
};

const call = async (path, method = 'GET', body) => {
  const res = await fetch(`${API_URL}${path}`, { method, headers: headers(), body: body ? JSON.stringify(body) : undefined });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data?.detail || 'Request failed'), { status: res.status });
  return data;
};

export const mediaUrl = (u, w) => {
  if (!u) return null;
  const abs = u.startsWith('/') ? `${API_URL}${u}` : u;
  return w && abs.includes('/api/media/') && !abs.includes('?') ? `${abs}?w=${w}` : abs;
};

export const fetchFlagshipPrograms = () => call('/api/programs/flagship');
export const fetchFlagshipProgram = (slug) => call(`/api/programs/flagship/${slug}`);
export const BANNER_TAP_KEY = (slug) => `rbr_banner_tap:${slug}`;
export const bannerTapFor = (slug) => {
  try {
    const t = JSON.parse(localStorage.getItem(BANNER_TAP_KEY(slug)) || 'null');
    if (!t || Date.now() - t.at > 7 * 86400000) return null;
    return t.aid;
  } catch { return null; }
};
export const startFlagshipProgram = (slug) => {
  const inv = localStorage.getItem('rbr_pending_invite'); const t = inv && inv.startsWith(`${slug}:`) ? inv.split(':')[1] : ''; if (t) localStorage.removeItem('rbr_pending_invite');
  const q = new URLSearchParams(); if (t) q.set('invite', t); const aid = bannerTapFor(slug); if (aid) q.set('banner', aid);
  const qs = q.toString();
  return call(`/api/programs/flagship/${slug}/start${qs ? `?${qs}` : ''}`, 'POST');
};
export const visitorId = () => {
  try {
    let v = localStorage.getItem('rbr_vid');
    if (!v) { v = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`; localStorage.setItem('rbr_vid', v); }
    return v;
  } catch { return null; }
};
export const announcementEvent = (aid, event, placement) => call(`/api/announcements/${aid}/event`, 'POST', { event, placement, vid: visitorId() }).catch(() => {});
export const fetchAnnouncements = (placement) => call(`/api/announcements/active?placement=${placement}`);
export const stepFlagshipDay = (slug, day, step, action, body) =>
  call(`/api/programs/flagship/${slug}/days/${day}/${step}/${action}`, 'POST', body || {});
export const trackProgramEvent = (slug, event, body) =>
  call(`/api/programs/flagship/${slug}/events/${event}`, 'POST', body || {}).catch(() => {});
export const shareToCircle = (content, circle, anonymous) =>
  call('/api/community/reflections', 'POST', { content, circle, anonymous });

export const NEED_ORDER = ['7-days-to-breathe-again', '7-nights-of-better-sleep', '14-days-of-healing-and-release', '21-days-of-self-worth', '30-days-with-rowdy'];

export const CONTINUE_DESTINATIONS = {
  '7-days-to-breathe-again': { to: '/category/anxiety', label: 'Continue Your Journey' },
  '7-nights-of-better-sleep': { to: '/category/sleep', label: 'Continue Your Journey' },
  '14-days-of-healing-and-release': { to: '/healing', label: 'Continue Healing' },
  '21-days-of-self-worth': { to: '/manifest/self-worth', label: 'Continue Your Journey' },
  '30-days-with-rowdy': { to: '/', label: 'Continue Your Journey' },
};

export const dayWord = (program, n) => `${program?.dayLabel || 'Day'}${n === 1 ? '' : 's'}`;
export const fmtMinutes = (s) => (s ? `${Math.max(1, Math.round(s / 60))} min` : '');

export const fetchFlagshipProgramPreview = (slug) => call(`/api/programs/flagship/${slug}?preview=1`);
export const getProgramReminders = () => call('/api/push/program-reminders');
export const setProgramReminders = (enabled) => call('/api/push/program-reminders', 'POST', { enabled });
export const getProgramReminderTimes = (slug) => call(`/api/programs/flagship/${slug}/reminders`);
export const setProgramReminderTimes = (slug, body) => call(`/api/programs/flagship/${slug}/reminders`, 'POST', body);
export const createPostcardShare = async (slug, blob, opts) => {
  const fd = new FormData();
  fd.append('image', blob, 'postcard.png');
  Object.entries(opts).forEach(([k, v]) => fd.append(k, String(v)));
  const res = await fetch(`${API_URL}/api/programs/flagship/${slug}/postcard-share`, { method: 'POST', headers: { Authorization: `Bearer ${localStorage.getItem('rbr_token')}` }, body: fd });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.detail || 'Could not create share link');
  return data;
};
export const disablePostcardShare = (token) => call(`/api/journey/${token}/disable`, 'POST');
export const fetchJourneyShare = (token) => call(`/api/journey/${token}/data`);
export const CIRCLE_CAPTIONS = {
  '7-days-to-breathe-again': 'I finished 7 Days to Breathe Again. One day at a time, I kept making room to breathe. 🌿',
  '7-nights-of-better-sleep': "I completed 7 Nights of Better Sleep. Tonight, I'm carrying forward a little more rest and a little less pressure. 🌙",
  '14-days-of-healing-and-release': "I completed 14 Days of Healing & Release. I'm still growing, still healing, and still choosing to move forward. 🌳",
  '21-days-of-self-worth': "I completed 21 Days of Self-Worth. One thing I'm carrying forward: my worth doesn't depend on someone else recognizing it. ✨",
  '30-days-with-rowdy': "I completed 30 Days With Rowdy. I breathed, released, rebuilt, reflected—and I'm going to keep becoming. 🌳",
};
export const myJourneyShares = () => call('/api/me/journey-shares');
export const enablePostcardShare = (token) => call(`/api/journey/${token}/enable`, 'POST');
export const createInvite = (slug, body) => call(`/api/programs/flagship/${slug}/invite`, 'POST', body);
export const fetchInvite = (token) => call(`/api/journey-invite/${token}/data`);
export const acceptInvite = (token, together) => call(`/api/journey-invite/${token}/accept`, 'POST', { together });
export const fetchBuddies = (slug) => call(`/api/programs/flagship/${slug}/buddies`);
export const sendBuddyNudge = (slug, pairToken, presetId) => call(`/api/programs/flagship/${slug}/buddies/nudge`, 'POST', { pairToken, presetId });
export const markNudgesSeen = (slug) => call(`/api/programs/flagship/${slug}/buddies/nudges/seen`, 'POST');
export const INVITE_COPY = {
  '7-days-to-breathe-again': "I'm taking a little more time to breathe. Want to do this seven-day journey with me?",
  '7-nights-of-better-sleep': 'I found a seven-night wind-down journey on Reflections by Rowdy. Want to try it with me?',
  '14-days-of-healing-and-release': 'I just completed this journey and thought it might give you some space for yourself too.',
  '21-days-of-self-worth': "I'm working on showing up for myself differently. Want to take this journey with me?",
  '30-days-with-rowdy': 'I finished 30 Days With Rowdy. Want to start your own journey?',
};
export const welcomeEvent = (slug, event) => call(`/api/programs/flagship/${slug}/welcome/${event}`, 'POST').catch(() => {});
export const shareReflection = (content, circle, anonymous, dedupeId) =>
  call('/api/community/reflections', 'POST', { content, circle, anonymous, dedupeId });

export const streakCopy = (n) => {
  if (!n || n < 2) return null;
  const opts = [`${n} days of showing up for yourself`, `${n} moments of choosing yourself`, `You've made space for yourself ${n} days in a row`, `One day at a time — ${n} days and you're still showing up`];
  return opts[n % opts.length];
};

// ---- admin
export const adminApi = {
  list: () => call('/api/admin/flagship-programs'),
  get: (id) => call(`/api/admin/flagship-programs/${id}`),
  patch: (id, body) => call(`/api/admin/flagship-programs/${id}`, 'PATCH', body),
  patchDay: (id, dayId, body) => call(`/api/admin/flagship-programs/${id}/days/${dayId}`, 'PATCH', body),
  reorder: (id, dayIds) => call(`/api/admin/flagship-programs/${id}/days/reorder`, 'POST', { dayIds }),
  action: (id, action, body) => call(`/api/admin/flagship-programs/${id}/${action}`, 'POST', body || {}),
  coverRegenerate: (id, coverDirection) => call(`/api/admin/flagship-programs/${id}/cover/regenerate`, 'POST', { coverDirection }),
  coverUse: (id, url) => call(`/api/admin/flagship-programs/${id}/cover/use`, 'POST', { url }),
  search: (params) => call(`/api/admin/flagship-content-search?${new URLSearchParams(params).toString()}`),
  audio: (cid) => call(`/api/admin/content/${cid}/audio`),
  audioCommit: (cid, body) => call(`/api/admin/content/${cid}/audio/commit`, 'POST', body),
  audioRollback: (cid, body) => call(`/api/admin/content/${cid}/audio/rollback`, 'POST', body),
  audioRegenTts: (cid, script) => call(`/api/admin/content/${cid}/audio/regenerate-tts`, 'POST', { script }),
  reminderTest: (body) => call('/api/admin/program-reminders/test', 'POST', body),
  analytics: (params) => call(`/api/admin/flagship-analytics?${new URLSearchParams(params).toString()}`),
  dayArchive: (id, dayId, action) => call(`/api/admin/flagship-programs/${id}/days/${dayId}/${action}`, 'POST'),
  dayReplace: (id, dayId, body) => call(`/api/admin/flagship-programs/${id}/days/${dayId}/replace`, 'POST', body || {}),
  recordings: (params) => call(`/api/admin/flagship-recordings?${new URLSearchParams(params).toString()}`),
  recordingsMatch: (body) => call('/api/admin/flagship-recordings/match', 'POST', body),
  recordingsCommit: (items) => call('/api/admin/flagship-recordings/commit', 'POST', { items }),
  imagePosts: (status) => call(`/api/admin/community/image-posts?status=${status}`),
  setVideo: (contentId, assetId) => call(`/api/admin/content/${contentId}/video`, 'POST', { assetId }),
  campaigns: () => call('/api/admin/campaigns'),
  campaign: (id) => call(`/api/admin/campaigns/${id}`),
  campaignDryRun: (id) => call(`/api/admin/campaigns/${id}/dry-run`, 'POST'),
  campaignTestSend: (id) => call(`/api/admin/campaigns/${id}/test-send`, 'POST'),
  campaignSend: (id, confirm) => call(`/api/admin/campaigns/${id}/send`, 'POST', { confirm }),
  setProductionVerified: (confirmed, note) => call('/api/admin/campaigns/production-verified', 'POST', { confirmed, note }),
  moderate: (id, action) => call(`/api/admin/community/reflections/${id}/${action}`, 'POST'),
  cohorts: (programId, attempts, range = '') => call(`/api/admin/flagship-cohorts?programId=${programId}&attempts=${attempts}${range ? `&dateFrom=${range}` : ''}`),
  welcomeCreate: (id, script, synthesize = true) => call(`/api/admin/flagship-welcome/${id}`, 'POST', { script, synthesize }),
  welcomeRemove: (id) => call(`/api/admin/flagship-welcome/${id}`, 'DELETE'),
  welcomeVideo: (id) => call(`/api/admin/flagship-welcome/${id}/video`),
  welcomeVideoSet: (id, assetId) => call(`/api/admin/flagship-welcome/${id}/video`, 'POST', { assetId }),
  welcomeVideoEnabled: (id, enabled) => call(`/api/admin/flagship-welcome/${id}/video/enabled`, 'POST', { enabled }),
  welcomeVideoClear: (id) => call(`/api/admin/flagship-welcome/${id}/video`, 'DELETE'),
  announcements: () => call('/api/admin/announcements'),
  announcementActivate: (id, active) => call(`/api/admin/announcements/${id}/activate`, 'POST', { active }),
  announcementSchedule: (id, body) => call(`/api/admin/announcements/${id}/schedule`, 'PUT', body),
  launchInsights: (params) => call(`/api/admin/launch-insights?${new URLSearchParams(params).toString()}`),
  pushAdminDevices: () => call('/api/push/admin-devices'),
  pushAdminTest: (which) => call('/api/push/admin-test', 'POST', { which }),
};
